import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Palette, Lightbulb, X } from "@phosphor-icons/react";
import { useHyperColor } from "@/context/HyperColorContext";

export default function HyperColorControl() {
  const { colorways, index, setIndex, uv, setUv } = useHyperColor();
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-24 right-4 z-40" data-testid="hypercolor-control">
      <AnimatePresence mode="wait">
        {!open ? (
          <motion.button
            key="btn"
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.6, opacity: 0 }}
            onClick={() => setOpen(true)}
            data-testid="hypercolor-toggle"
            className="h-11 w-11 grid place-items-center rounded-full bg-primary text-primary-foreground shadow-lg neon-glow pulse-ring"
            title="Hypercolor & Lightswitch"
          >
            <Palette weight="fill" size={20} />
          </motion.button>
        ) : (
          <motion.div
            key="panel"
            initial={{ opacity: 0, y: -10, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.96 }}
            className="bg-popover/95 backdrop-blur border border-primary/40 rounded-2xl p-4 w-60 neon-glow"
            data-testid="hypercolor-panel"
          >
            <div className="flex items-center justify-between mb-3">
              <span className="overline text-primary">Hypercolor</span>
              <button onClick={() => setOpen(false)} data-testid="hypercolor-close" className="h-7 w-7 grid place-items-center rounded-md text-muted-foreground hover:text-white hover:bg-white/10 transition-colors">
                <X size={15} />
              </button>
            </div>
            <div className="grid grid-cols-5 gap-2 mb-4">
              {colorways.map((c, i) => (
                <button
                  key={c.name}
                  title={c.name}
                  onClick={() => setIndex(i)}
                  data-testid={`hypercolor-${c.name.replace(/\s/g, "")}`}
                  className={`h-8 w-8 rounded-full border-2 transition-transform hover:scale-110 ${index === i ? "border-white scale-110" : "border-white/20"}`}
                  style={{ background: c.hex, boxShadow: index === i ? `0 0 12px ${c.hex}` : "none" }}
                />
              ))}
            </div>
            <button
              onClick={() => setUv(!uv)}
              data-testid="lightswitch-toggle"
              className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl border transition-colors ${uv ? "bg-secondary/20 border-secondary text-secondary" : "border-white/15 text-muted-foreground hover:text-white"}`}
            >
              <span className="overline flex items-center gap-2"><Lightbulb weight="fill" size={16} /> Lightswitch</span>
              <span className="text-xs font-semibold">{uv ? "UV ON" : "OFF"}</span>
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
